import { useState } from 'react';
import { Outlet } from 'react-router-dom';

import { SidebarNav } from './sidebar-nav.jsx';
import { Topbar } from './topbar.jsx';

import cirunLogo from '@/assets/cirun-logo-inverted.svg';
import cirunLogoLight from '@/assets/cirun-logo-light-theme.png';
import cirunMark from '@/assets/cirun-mark.png';
import { ROUTES } from '@/config/routes.js';
import { cn } from '@/lib/utils.js';
import { useTheme } from '@/providers/theme-provider.jsx';

const SIDEBAR_COLLAPSED_KEY = 'cirun:sidebar-collapsed';

export function AppShell({ userMenuSlot }) {
  const { resolvedTheme } = useTheme();
  const wordmark = resolvedTheme === 'dark' ? cirunLogo : cirunLogoLight;
  const [collapsed, setCollapsed] = useState(() => {
    try {
      return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === '1';
    } catch {
      return false;
    }
  });
  const toggleCollapsed = () => {
    setCollapsed((prev) => {
      const next = !prev;
      try {
        localStorage.setItem(SIDEBAR_COLLAPSED_KEY, next ? '1' : '0');
      } catch {
        // ignore quota / private-mode failures
      }
      return next;
    });
  };

  return (
    <div className="admin-mono flex min-h-screen bg-background text-foreground">
      <aside
        className={cn(
          'hidden shrink-0 border-r border-border bg-background transition-[width] duration-200 lg:block',
          collapsed ? 'w-16' : 'w-52',
        )}
      >
        <a
          href={ROUTES.ROOT}
          className="flex h-20 items-center justify-center px-3"
          aria-label="cirun"
        >
          {collapsed ? (
            <img src={cirunMark} alt="cirun" className="h-9 w-9" />
          ) : (
            <img src={wordmark} alt="cirun" className="h-[75px] w-auto" />
          )}
        </a>
        <SidebarNav collapsed={collapsed} />
      </aside>
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar userMenuSlot={userMenuSlot} onToggleSidebar={toggleCollapsed} />
        <main className="container mx-auto max-w-7xl px-4 pt-8 pb-10 md:px-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
